import React from "react";
// import BannerSectionStyle7 from '../Section/BannerSection/BannerSectionStyle7';
import Section from "../Section";
// import AppointmentSection from '../Section/AppointmentSection';
// import BreadcrumbStyle2 from '../Breadcrumb/BreadcrumbStyle2';
// import AboutSectionStyle2 from '../Section/AboutSection/AboutSectionStyle2';
// import FeaturesSectionStyle3 from '../Section/FeaturesSection/FeaturesSectionStyle3';
import TeamSectionStyle3 from "../Section/TeamSection/TeamSectionStyle3";
import { pageTitle } from "../../helpers/PageTitle";
// import Breadcrumb from '../Breadcrumb';
// import WorkingProcess from '../Section/WorkingProcess';
import BannerSectionStyle2 from "../Section/BannerSection/BannerSectionStyle2";
import FaqSectionStyle3 from "../Section/FaqSection/FaqSectionStyle3";
import DoctorDetailsSection from "../Section/DoctorDetailsSection";
import { Specification } from "./Specification";
import { ProductFeaturesDetails } from "./ProductFeaturesDetails";
import ProductsDetailMainSection from "./ProductsDetailMainSection";
import Spacing from "../Spacing";
import { Helmet } from "react-helmet";

export default function MercuryCare() {
  pageTitle("Mercury Mini");
  return (
    <>
      <Helmet>
        <title>
          Mercury Mini – Portable Heater-Cooler Unit for Surgery | Mercury
          Healthcare Manufacturer & Supplier
        </title>

        <meta
          name="Keyword"
          content="Heater cooler machine, Heater cooler unit, Hyper-Hypothermia, Hyper-Hypothermia unit, Hyper-Hypothermia Machine Manufacture, Heater Cooler Machine, Fast Cooling machine, Fast Cooling, Hypothermia Machine"
        />
        <meta
          name="description"
          content="Mercury Mini is a portable heater-cooler unit for ECMO, ICU, and pediatric surgeries. Features a 5L tank, dual output, touch control, and fast heating."
        />
        {/* Google Tag (gtag.js) */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-MGF4V7P4YB"
        ></script>
        <script>
          {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-MGF4V7P4YB');
      `}
        </script>
      </Helmet>

      <Section topMd={170} topLg={145} topXl={90} bottomLg={90}>
        <div className="cs_doctor_details">
          <div className="cs_doctor_details_bg cs_bg_filed" />
          <Spacing md="85" />
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="cs_single_doctor overflow-hidden cs_radius_20 p-5">
                  <img
                    src="/images/departments/Mercury Care.png"
                    alt="Doctor"
                    className="w-100 cs_radius_20 "
                  />
                  <h3
                    className="cs_white_color cs_accent_bg mb-0 text-center cs_semibold cs_fs_24"
                    style={{
                      padding: "14px 15px",
                    }}
                  >
                    Mercury Care
                  </h3>
                </div>
              </div>
              <div className="col-lg-6   position-relative">
                <Spacing md="55" />
                <h1
                  className="cs_fs_120 mb-0 cs_semibold"
                  style={{
                    fontSize: "45px",
                    color: "#3f48cc",
                  }}
                >
                  Mercury Care
                </h1>

                <Spacing md="32" />
                <p className="mb-0 cs_heading_color">
                  {" "}
                  Mercury Care is Heater-Cooler Unit. Care is used to maintain
                  the body temperature through conductive heat transfer. The
                  conductive heat transfer is accomplished through blanket under
                  the patient. The user regulates the desired fluid temperature
                  with continuous monitoring
                </p>

                <p
                  style={{
                    color: "#274760",
                  }}
                >
                  <Spacing md="32" />
                  <h4 className="underline"> Applications</h4>
                  <p
                    style={{
                      color: "#274760",
                    }}
                  >
                    {" "}
                    Mercury Care can be used for Liver transplant, ICU and
                    Critical care unit to maintain patients body temperature.
                  </p>
                 
                </p>
              </div>
            </div>
          </div>
        </div>
      </Section>

      <Section topMd={170} topLg={145} topXl={90} bottomLg={90}>
        <div className="container">
          <div className="img-details-container">
            {/* Left Section: Features and Product Images */}
            <div className="left-section">
              {/* Title */}
              {/* <h2>{item.tittle}</h2> */}

              {/* Features List */}
              <div className="featureList">
                <h4 className="underline">Features</h4>

                <div className="listdata">
                  <ul>
                    <li>
                      <strong>Fastest Heating and Cooling:</strong> It has 7
                      Litre water tank with 1500W heaters to achieve desired set
                      point quickly.
                    </li>
                    <li>
                      <strong>Graphical User Interface:</strong> Visual & easy
                      to use graphical interface for water flow & temperature.
                    </li>
                    <li>
                      <strong>Fully Touch Controller Display:</strong> All
                      parameter can be controlled on finger touch.
                    </li>
                    <li>
                      <strong>Robust Design:</strong> Robust design including
                      PLC based electronics to avoid periodic repairs.
                    </li>
                    <li>
                      <strong>Two Output Circuits:</strong> It can be used to
                      support two patient simultaneously.
                    </li>
                 
                    <li>
                      <strong>Auto Mode:</strong> Smart operation for ease of
                      use.
                    </li>
                  </ul>
                </div>
              </div>

              {/* Product Images */}
              {/* <div className="Bottomside">

                <img src="/images/departments/Mercury Mini.jpg" />
                <img src="/images/departments/Mercury Mini.jpg" />
                <img src="/images/departments/Mercury Mini.jpg" />
                <img src="/images/departments/Mercury Mini.jpg" />
                <img src="/images/departments/Mercury Mini.jpg" />

              </div> */}
            </div>

            {/* Right Section: Side Images */}
            {/* <div className="rightside">

              <img src="/images/departments/Mercury Mini.jpg" />
              <img src="/images/departments/Mercury Mini.jpg" />
              <img src="/images/departments/Mercury Mini.jpg" />

            </div> */}
          </div>
        </div>
      </Section>

      <Section topMd={170} topLg={145} topXl={10} bottomLg={90}>
        <div className="container">
          <h3 className="underline">Specifications</h3>
          <div className="specification">
            <div className="leftside-specification">
              <div>
                <h4>Dimensions:</h4>
                <ul>
                  <li> Height: 32.67" (83 cm)</li>
                  <li> Width: 17.12" (43.5 cm)</li>
                  <li>Length: 20.66" (52.5 cm)</li>
                  <li> Weight: 165.34 lbs. (75 kg)</li>
                </ul>
              </div>
              <div>
                <h4> Power Supply: </h4>
                <ul>
                  <li> Voltage: 220 VAC, 1 Phase</li>
                  <li> Frequency: 50Hz </li>
                  <li> Current: 15A </li>
                  <li> Leakage Current: 500mA max </li>
                </ul>
              </div>
            </div>
            <div className="rightside-specification">
              <div>
                <h4> Water Tank: </h4>
                <ul>
                  <li>Capacity: 7 Liter (1.84 Gal), Single tank</li>
                  <li>Size: 16 x 19.7 x 18.7 CMs </li>
                  <li>Temperature Range: 3-42°C (37.4-107°F)</li>
                </ul>
              </div>

              <div>
                <h4>Heaters: </h4>
                <ul>
                  <li>Heaters: 02 Numbers </li>
                  <li>Heater wattage: 750 watt each </li>
                </ul>
              </div>
              <div>
                <h4>Output Ports: </h4>
                <ul>
                  <li>Patient 1: Quick Connect, 2 Ltr/min </li>
                  <li>Patient 2: Quick Connect, 2 Ltr/min </li>
                </ul>
              </div>
            </div>
          </div>

          <Spacing md="32" />
        </div>
      </Section>
    </>
  );
}
